import { createAction } from '@reduxjs/toolkit';

export const donationUpdateId = createAction('donation/updateId');
export const donationUpdateUID = createAction('donation/updateUid');
export const donationUpdateSID = createAction('donation/updateSid');
export const donationUpdateIsAdded = createAction('donation/updateIsAdded');
export const donationUpdateIsActive = createAction('donation/updateIsActive');

export const donationStore = createAction('donation/store');
export const donationClear = createAction('donation/clear');

export const donationUpdateRequest = createAction('donation/updateRequest');
export const donationUpdateError = createAction('donation/updateError');
export const donationUpdateStore = createAction('donation/updateStore');

export const donationUpdateItemIcon = createAction('donation/updateItemIcon');
export const donationUpdateItemTitle = createAction('donation/updateItemTitle');
export const donationUpdateItemPrice = createAction('donation/updateItemPrice');

export const donationUpdateButtonTitle = createAction('donation/updateButtonTitle');
export const donationUpdateButtonBackgroundColor = createAction('donation/updateButtonBackgroundColor');
export const donationUpdateButtonTextColor = createAction('donation/updateButtonTextColor');
export const donationUpdateMessage = createAction('donation/updateMessage');
export const donationUpdateHeader = createAction('donation/updateHeader');
export const donationUpdateView = createAction('donation/updateView');
export const donationUpdateIsComment = createAction('donation/updateIsComment');
export const donationUpdateIsName = createAction('donation/updateIsName');
export const donationUpdateIsPhone = createAction('donation/updateIsPhone');

export const donationUpdateSectionType = createAction('donation/updateSectionType');
export const donationUpdateAmounts = createAction('donation/updateAmounts');

export const donationUpdateThemeColor = createAction('donation/updateThemeColor');
export const donationUpdateThemeTextColor = createAction('donation/updateThemeTextColor');

export const donationUpdateHeadingTitle = createAction('donation/updateHeadingTitle');
export const donationUpdateHeadingDescription = createAction('donation/updateHeadingDescription');
export const donationUpdateHeadingTextAlign = createAction('donation/updateHeadingTextAlign');
export const donationUpdateHeadingImage = createAction('donation/updateHeadingImage');
export const donationUpdateHeadingDivider = createAction('donation/updateHeadingDivider');

export const donationUpdateSectionIsBackground = createAction('donation/updateSectionIsBackground');
export const donationUpdateSectionTextColor = createAction('donation/updateSectionTextColor');
export const donationUpdateSectionBackgroundColor = createAction('donation/updateSectionBackgroundColor');
export const donationUpdateSectionOpacity = createAction('donation/updateSectionOpacity');
export const donationUpdateSectionIsFullWidth = createAction('donation/updateSectionIsFullWidth');
export const donationUpdateSectionShadow = createAction('donation/updateSectionShadow');
export const donationUpdateSectionShadowColor = createAction('donation/updateSectionShadowColor');
export const donationUpdateSectionPadding = createAction('donation/updateSectionPadding');
export const donationUpdateSectionMargin = createAction('donation/updateSectionMargin');
export const donationUpdateSectionBackgroundType = createAction('donation/updateSectionBackgroundType');
export const donationUpdateSectionBackgroundImage = createAction('donation/updateSectionBackgroundImage');
export const donationUpdateSectionGradientColor1 = createAction('donation/updateSectionGradientColor1');
export const donationUpdateSectionGradientColor2 = createAction('donation/updateSectionGradientColor2');
export const donationUpdateSectionGradientDirection = createAction('donation/updateSectionGradientDirection');
export const donationUpdateSectionGradientOffset = createAction('donation/updateSectionGradientOffset');
export const donationUpdateSectionBorder = createAction('donation/updateSectionBorder');
export const donationUpdateSectionBorderColor = createAction('donation/updateSectionBorderColor');
export const donationUpdateSectionShadowBorderColor = createAction('donation/updateSectionShadowBorderColor');
export const donationUpdateSectionShape = createAction('donation/updateSectionShape');
